module.exports = __webpack_public_path__ + "img/amllogo.353b881f.png";